import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function SplashScreen() {
  const navigate = useNavigate();
  const { isLoading, isAuthenticated } = useAuth();

  useEffect(() => {
    // Minimum splash time for a native feel
    const minTime = new Promise((r) => setTimeout(r, 1400));
    (async () => {
      await minTime;
      if (isLoading) return; // wait
      const onboarded = localStorage.getItem("sib_onboarded");
      if (isAuthenticated) {
        navigate("/app", { replace: true });
      } else if (onboarded) {
        // Already seen onboarding — drop them into the app as a guest
        navigate("/app", { replace: true });
      } else {
        navigate("/onboarding", { replace: true });
      }
    })();
  }, [isLoading, isAuthenticated, navigate]);

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-[#1F3A5F] via-[#264a78] to-[#4FB3A5] text-white"
      data-testid="splash-screen"
    >
      <div className="animate-fadeIn flex flex-col items-center gap-6">
        <div className="w-24 h-24 rounded-[22%] bg-white flex items-center justify-center shadow-2xl">
          <svg
            viewBox="0 0 64 64"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="w-16 h-16"
          >
            <path
              d="M32 6C16 6 6 17 6 28C6 34 9 40 15 44V54L27 47C29 47 30 48 32 48C48 48 58 37 58 28C58 17 48 6 32 6Z"
              fill="#2F5BFF"
            />
            <path
              d="M32 38L28 34C20 27 16 23 16 18C16 14 19 11 24 11C27 11 29 12 32 15C35 12 37 11 40 11C45 11 48 14 48 18C48 23 44 27 36 34L32 38Z"
              fill="white"
            />
          </svg>
        </div>
        <h1 className="text-3xl font-bold tracking-tight">SayItBetter</h1>
        <p className="text-sm text-white/80 max-w-xs text-center px-4">
          Say what you mean — without damaging the relationship.
        </p>
        <div className="mt-6">
          <div className="w-8 h-8 rounded-full border-2 border-white/30 border-t-white animate-spin"></div>
        </div>
      </div>
    </div>
  );
}
